import { createSelector } from '@reduxjs/toolkit'
import { ISelectUnits } from './reducer'

const rootState = (state: ISelectUnits) => state.selectUnits

export const getSelectedUnits = createSelector(
  rootState,
  (state) => state.selectedUnits
)

export const getSelectedIndividualUnits = createSelector(
  rootState,
  (state) => state.selectedIndividualUnits
)

export const getUnits = createSelector(rootState, (state) => state.units)

export const getUnitsClimate = createSelector(
  rootState,
  (state) => state.unitsClimate
)

export const getUnitsCovered = createSelector(
  rootState,
  (state) => state.unitsCovered
)

export const getRow0 = createSelector(rootState, (state) => state.row0)

export const getRow1 = createSelector(rootState, (state) => state.row1)

export const getRow2 = createSelector(rootState, (state) => state.row2)

export const getRow3 = createSelector(rootState, (state) => state.row3)

export const getRow4 = createSelector(rootState, (state) => state.row4)

export const getAllRows = createSelector(rootState, (state) => [
  ...state.row0,
  ...state.row1,
  ...state.row2,
  ...state.row3,
  ...state.row4,
])
